import React from 'react';

import SVGIcon, { BASE_ICONS } from 'src/components/svg';
import { popupModel, TableLibrary } from 'src/components/complex';
import BaseComponent from 'src/components/BaseComponent';

import { addressObject, scssVariables as variables, withRouter } from 'src/helpers';

import Schedule from 'src/components/location/Schedule';
import AddLocation from 'src/components/location/AddLocation';
import { MCButton } from 'src/components/basic';

import model from 'src/components/location/model';
import LANG_CONST from 'src/helpers/lang/const';
import { remCss } from 'src/helpers';

class Location extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }
  nextBtn = (event) => {
    event.preventDefault();
    this.props.router.navigate('/signup-clinic/confirm');
  };

  prevBtn = (event) => {
    event.preventDefault();
    this.props.router.navigate('/signup-clinic/info');
  };
  render = () => {
    let loading = model.refreshing();
    let items = model.items();
    let { openId } = model.state;

    let noResults = model.noResults();
    let { total = 0 } = model.getCurrent();
    let searchQuery = model.listInput('search');
    return (
      <>
        <TableLibrary
          className={'mc-mb10 mc-grow ' + (this.props.className || '')}
          template={1}
          loading={loading}
          noResults={noResults}
          searchQuery={searchQuery}
          sortBy={model.state.sortBy}
          selectedPage={model.state.pageIndex}
          total={total}
          limit={model.listLimit}
          showPagination={!!this.props.showPagination}
          onSetPage={(v) => {
            model.handleChange('pageIndex', v);
            model.setListState({ items: [] }, model.getCurrentId(), null, true);
            model.loadMore();
          }}
          renderExtend={(item) => openId === item.id && <Schedule item={item} model={model} />}
          columns={[
            {
              label: LANG_CONST.city,
              onClick: (item) => model.setState({ openId: openId === item.id ? null : item.id }),

              renderCell: (item) => (
                <div
                  className={'mc-pointer'}
                  onClick={() => model.setState({ openId: openId === item.id ? null : item.id })}
                >
                  {
                    addressObject({
                      cityAddress: item.city,
                      countryAddress: item.country,
                      stateAddress: item.state
                    }).fullAddressNameReverse
                  }
                </div>
              )
            },
            {
              label: LANG_CONST.institution,
              renderCell: (item) => (
                <div
                  className={'mc-pointer'}
                  onClick={() => model.setState({ openId: openId === item.id ? null : item.id })}
                >
                  {item.hospital?.split('_')[0]}
                </div>
              )
            },
            {
              label: 'Actions',
              cellStyles: { textAlign: 'end' },
              width: `${remCss(170)}px`,
              renderCell: (item) => (
                <div
                  className={'mc-flex mc-wrap mc-expand ' + (openId === item.id ? 'open' : 'close')}
                  style={{ justifyContent: 'flex-end' }}
                >
                  <MCButton
                    onClick={() => model.setState({ openId: openId === item.id ? null : item.id })}
                    tiny
                    primary
                    light
                    radius
                  >
                    <span
                      className={'mc-rotate ' + (openId === item.id ? 'mc-rotate-180' : '')}
                      style={{ height: remCss(30) }}
                    >
                      <SVGIcon
                        iconname={BASE_ICONS.DOWN}
                        width={30}
                        padding={5}
                        fill={variables['colors-mc-primary']}
                      />
                    </span>
                  </MCButton>
                </div>
              )
            }
          ]}
          data={items}
          emptyText={this.props.emptyText}
        />
        {this.props.showAddBtn && (
          <div>
            <MCButton
              primary
              light
              medium
              radius
              type={'button'}
              label={LANG_CONST.buttons.add_location}
              iconname={BASE_ICONS.PLUS}
              onClick={() => {
                // model.resetLocation();
                popupModel.setActivePopup('add_location', {
                  active: true,
                  component: AddLocation,
                  props: { model }
                });
              }}
            />
          </div>
        )}
      </>
    );
  };
}

export default withRouter(Location);
